import React, { FC } from 'react'
import type { CoachCTABlock as BlockProps } from '@/payload-types'
import { CoachCTA } from '@/components/CoachCTA'

export const CoachCTABlock: FC<BlockProps> = ({ links, richText, media, height }) => {
  return (
    <CoachCTA
      links={links || []}
      richText={richText}
      media={media}
      height={height ? Number(height) : undefined}
    />
  )
}
